import { useFormatDate, useT } from "src/internationalization";
import { ScenarioExecutionResultWithCase } from "src/types/scenario";

export function PrintableRulesWidget({
  execution,
  manual,
}: {
  execution?: ScenarioExecutionResultWithCase | null;
  manual: boolean;
}) {
  const formatDate = useFormatDate();
  const t = useT();
  if (manual)
    return (
      <p>
        {t("caseVersions.diff.executions.manual.alert")} ·{" "}
        {t("page.alert.pdf.rules.execution.none")}.
      </p>
    );
  if (!execution) return <p>{t("page.alert.pdf.rules.execution.none.available")}.</p>;

  return (
    <>
      <dl className="grid grid-cols-2 gap-x-6 gap-y-2 bg-layer01 py-4 px-5 mb-4 text-label01">
        <div>
          <dt className="text-textSecondary">{t("scenarios.title")}</dt>
          <dd className="font-semibold">{execution.scenarioVersion?.scenario?.name}</dd>
        </div>
        <div>
          <dt className="text-textSecondary">{t("page.alert.pdf.version.title")}</dt>
          <dd className="font-semibold">{execution.scenarioVersion?.name}</dd>
        </div>
        <div>
          <dt className="text-textSecondary">{t("page.alert.pdf.rules.execution.date")}</dt>
          <dd className="font-semibold">
            {formatDate(execution.date, { dateStyle: "medium", timeStyle: "short" })}
          </dd>
        </div>
        <div>
          <dt className="text-textSecondary">Score</dt>
          <dd className="font-semibold">{execution.globalScore}</dd>
        </div>
      </dl>

      {execution.ruleExecutionDetails.length ? (
        execution.ruleExecutionDetails.map((result) => (
          <div
            className="printable-rule border-b border-solid border-b-borderSubtle pb-2"
            key={result.id}
          >
            <h3 className="text-heading01 font-heading01 mt-1">
              {result.rule?.name ?? "Règle indisponible"}
            </h3>
            <strong>Score : {result.ruleScore}</strong>
          </div>
        ))
      ) : (
        <p>{t("page.alert.pdf.rule.none")}.</p>
      )}
    </>
  );
}
